import { Vehicle, VehicleFeature } from '@/catalog/types/vehicle';
import { withPageContainerStyles } from '@/common/components/page-layout';
import Spacer from '@/common/components/spacer';
import PDPSectionContainer, { PDPSectionContainerProps } from './pdp-section-container';
import Essentials from './essentials';
import { getEssentialsData } from '@/common/utils/get-essentials-data';
import Features from './features';
import Specifications from './specifications';

interface FeaturesSpecsProps
  extends Pick<PDPSectionContainerProps, 'onInViewChange' | 'addSectionRef'> {
  featuresSpecs?: VehicleFeature[];
  vehicle: Vehicle;
}

export default function FeaturesSpecs({
  featuresSpecs,
  onInViewChange,
  addSectionRef,
  vehicle,
}: FeaturesSpecsProps) {
  const essentials = getEssentialsData(vehicle);

  return (
    <PDPSectionContainer
      sectionKey="features"
      onInViewChange={onInViewChange}
      addSectionRef={addSectionRef}
    >
      <div
        className={withPageContainerStyles(
          'max-w-[1440px] px-[16px] py-[88px] md:px-[24px] md:py-[120px]'
        )}
      >
        <h2 className="header-sans-tight hidden tracking-normal md:block">
          Features & specs
        </h2>
        <h3 className="header-sans-tight block tracking-normal md:hidden">
          Features & specs
        </h3>

        <Spacer variant="height40" hideForBreakpoints={['sm']} />
        <Spacer variant="height24" hideForBreakpoints={['md', 'lg', 'xl', '2xl']} />

        <div className="flex flex-col gap-4 md:gap-6">
          <Essentials essentials={essentials} />
          {/* New prop sortAscending to control sorting order */}
          {featuresSpecs ? (
            <>
              <Features featuresSpecs={featuresSpecs} sortAscending={true} />
              <Specifications featuresSpecs={featuresSpecs} sortAscending={true} />
            </>
          ) : null}
        </div>
      </div>
    </PDPSectionContainer>
  );
}
